module.exports = __webpack_public_path__ + "static/halsey-9cd6e886fca5368d11d4e0aafaa1c3c0.jpg";